export default __webpack_public_path__ + "static/media/mini-human-body-front.ace7f092.png";